import styled, { css, keyframes } from "styled-components";

export const Wrapper = styled.header`
  align-items: center;
  justify-content: space-between;
  display: none;
  max-width: 1440px;
  padding: 32px 64px 0;
  margin: 0 auto;


  @media (min-width: 1200px) {
    display: flex;
  }

  @media (min-width: 1440px) {
    padding: 32px 120px 0;
  }
`;

export const Logo = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const ButtonBox = styled.div`
  display: flex;
  gap: 12px;
`;

export const BtnMenu = styled.button`
  ${({ active }) => css`
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid transparent;
    transition: all 0.3s ease-out;
    background-color: transparent;

    ${active &&
    css`
        background-image:
          linear-gradient(var(--color-002C81), var(--color-002C81)),
          linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
        background-origin: border-box;
        background-clip: padding-box, border-box;
        border: 1px solid transparent;
    `}

    &:hover{
      background-image: linear-gradient(var(--color-003fb9), var(--color-003fb9)),
      linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
      background-origin: border-box;
      background-clip: padding-box, border-box;
      border: 1px solid transparent;
    } 
  `}
`



export const ActionBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 257px;
  min-height: 40px;
  border-radius: 8px;
  border-width: 1px;
  padding-top: 8px 16px;
  gap: 8px;
  opacity: 1;
  font-weight: 600;
  font-style: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  background-image: linear-gradient(var(--color-A62AFF), var(--color-A62AFF)),
  linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
  background-origin: border-box;
  background-clip: padding-box, border-box;
  border: 1px solid transparent;

  &:hover{
      background-image: linear-gradient(var(--color-3F145E), var(--color-3F145E)),
  linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
    } 
`


// ⬇️ wrapper inline para não mexer no layout existente
export const DropWrap = styled.span`
  position: relative;
  display: inline-block; /* ocupa o mesmo espaço do botão */
`;

// ⬇️ animação leve (não interfere no resto)
const fadeDown = keyframes`
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
`;

// ⬇️ dropdown “neutro”: posicionado sob o botão; nenhuma alteração nos seus tamanhos do header
export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 220px;
  background: #0f1524;
  border: 1px solid rgba(106,157,255,.35);
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 10px 30px rgba(0,0,0,.35);
  z-index: 1000;
  animation: ${fadeDown} .16s ease forwards;

  &::before {
    content: "";
    position: absolute;
    top: -8px; left: 16px;
    width: 14px; height: 14px;
    background: inherit;
    border-left: inherit; border-top: inherit;
    transform: rotate(45deg);
  }
`;

export const DropItem = styled.button`
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  padding: 10px 12px;
  border-radius: 10px;
  color: #e8edff;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.2;

  &:hover { background: rgba(106,157,255,.12); }
  &:active { background: rgba(106,157,255,.18); }
  &:focus-visible { outline: 2px solid var(--color-6A9DFF, #6a9dff); }
`;

export const DropLink = styled(DropItem).attrs({
  as: "a",
})`
  display: block;
  width: 100%;
  box-sizing: border-box;
  text-decoration: none;
  color: inherit;
`;